export const DATE_FORMAT = 'DD MMM YY'
export const DATE_FORMAT_NO_YEAR = 'DD MMM'
